exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".favoritesDialog .dialogLoadingBlock[data-v-1288a748] {\n  width: 100%;\n  height: 400px;\n  background: #fff;\n}\n", ""]);

// exports
